var $957f034d30ca532a$exports = {};
$957f034d30ca532a$exports = {
    "endTime": `Kone\u{10D}n\xfd \u{10D}as`,
    "startTime": `Po\u{10D}\xe1te\u{10D}n\xed \u{10D}as`,
    "time": `\u{10C}as`
};


export {$957f034d30ca532a$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
